import axios from "axios";
import { createContext, useState } from "react";
import { loginCookieName } from "../App";
import api from "../context/api";
import { eraseCookie, getCookie } from "../Cookie";
import GLTFExporterExt from "../THREE_EXT/GLTFExporterExt";

const SettingsContext = createContext();

const initialExportObj = [
  { name: "Export Scene", isSelected: false },
  { name: "USDZ", isSelected: false },
  { name: "Match ", isSelected: true },
  { name: "Draco", isSelected: true },
];

const initialLighting = [
  { name: "Exposure", value: 1.0 },
  { name: "Shadow", value: 1.0 },
  { name: "shadow-softness", value: 1.0 },
];

/* sugar-domain-ext com.sugar.domain.product.PlacementType'a bakılarak güncellene
 */
const initializePlacementTypes = [
  {
    label: "Zemin",
    value: 0,
  },
  {
    label: "Duvar",
    value: 1,
  },
  {
    label: "Tavan",
    value: 5,
  },
  {
    label: "Zemin ve Duvar",
    value: 2,
  },
  {
    label: "Zemin ve Nesne",
    value: 6,
  },
  {
    label: "Zemin, Duvar ve Nesne",
    value: 3,
  },
  {
    label: "Zemin, Duvar ve Tavan",
    value: 4,
  },
  {
    label: "Şömine",
    value: 20,
  },
];

const SettingsProvider = ({ children }) => {
  const [id, setId] = useState(window.location.pathname.replace("/", ""));

  const [name, setName] = useState("");

  const [disabled, setDisabled] = useState(false);

  const [exportObj, setExportObj] = useState(initialExportObj);

  const [isNewObj, setIsNewObj] = useState(true);

  const [lightingObj, setLightingObj] = useState(initialLighting);

  const [company, setCompany] = useState(null);

  const [companies, setCompanies] = useState([]);

  const [materials, setMaterials] = useState([]);
  const [materialGroups, setMaterialGroups] = useState([]);

  const [categories, setCategories] = useState([]);
  const [categoryList, setCategoryList] = useState([]);

  const [globalCategories, setGlobalCategories] = useState([]);
  const [globalCategoryList, setGlobalCategoryList] = useState([]);

  const [selectedCategoryList, setSelectedCategoryList] = useState([null]);

  const [selectedG_CategoryList, setSelectedG_CategoryList] = useState([null]);

  const [thumbnail, setThumbnail] = useState([]);

  const [gltfMaterials, setGltfMaterials] = useState([]);

  const [gltfFile, setGltfFile] = useState([]);

  const [imageList, setImageList] = useState([]);

  const [companyMaterialGroups, setCompanyMaterialGroups] = useState([]);

  const [placeType, setPlaceType] = useState({
    value: 0,
    label: "Zemin",
  });

  const [placeTypes, setPlaceTypes] = useState(initializePlacementTypes);

  const [productToUpdate, setProductToUpdate] = useState({});

  const [productMatches, setProductMatches] = useState([]);

  const [environment, setEnviroment] = useState([null]);
  const [environmentList, setEnvironmentList] = useState([]);

  const [pMaterialParts, setPMaterialParts] = useState([]);

  const [productJson, setProductJson] = useState([]);

  const [matchProductCode, setMatchProductCode] = useState(null);

  const [useThumbnail, setUseThumbnail] = useState(false);

  const [usePoster, setUsePoster] = useState(false);

  const [cameraOrbit, setCameraOrbit] = useState("0deg 75deg auto");

  const [sceneActive, setSceneActive] = useState(true);

  const [defaultProductMaterialGroups, setDefaultProductMaterialGroups] =
    useState({});

  const [glbOriginalFile, setGlbOriginalFile] = useState();

  const [annotationList, setAnnotationList] = useState([]);
  const [animationAnnotationList, setAnimationAnnotationList] = useState([]);

  const [lowGlb, setLowGlb] = useState([]);

  const [defaultModelGroups, setDefaultModelGroups] = useState({});
  const [modelOptionList, setModelOptionList] = useState();
  const [productOptions, setProductOptions] = useState();

  const [tagList, setTagList] = useState([]);
  const [tagGroupList, setTagGroupList] = useState([]);
  const [refreshMaterial, setRefreshMaterial] = useState(0);

  const [dracoCompressionLevel, setDracoCompressionLevel] = useState("10");

  const [authenticationToken, setAuthenticationToken] = useState(
    getCookie(loginCookieName)
  );
  const [authorizationHeader, setAuthorizationHeader] = useState({
    headers: {
      Authorization: authenticationToken,
    },
  });

  const [animations, setAnimations] = useState(null);

  const [productVariantOptions, setProductVariantOptions] = useState([]);

  const [transmissionParams, setTransmissionParams] = useState([]);

  const exporter = new GLTFExporterExt();

  const editorProductInfo = {
    id: id,
    name: name,
    category: categories,
    globalCategory: globalCategories,
    exposure: lightingObj[0].value,
    shadow: lightingObj[1].value,
    matchProduct: exportObj[2].isSelected,
    exportUsdz: exportObj[1].isSelected,
    isNewObj: isNewObj,

    company:
      company && company.value
        ? {
            id: company.value,
            name: company.label,
          }
        : {},

    hdr: environment && environment.value ? { id: environment.value } : null,
    xWidth: 0,
    yHeight: 0,
    zDepth: 0,
    pMaterialParts: pMaterialParts,
    dracoCompress: false, //exportObj[3].isSelected,
    dracoLevel: dracoCompressionLevel,
    exportPoster: usePoster,
    exportThumbnail: useThumbnail,
    matchProductCode: matchProductCode,
  };

  const getProductToUpdate = async (productId) => {
    let url =
      process.env.REACT_APP_BACKEND_API + "editor/get/product/" + productId;
    return axios
      .get(url, {
        headers: {
          Authorization: authenticationToken,
        },
      })
      .then((res) => {
        if (typeof res.data != "object") return null;
        setIsNewObj(false);
        setProductToUpdate(res.data);
        setProductInfos(res.data);
        setProductJson(res.data);
        return res.data;
      });
  };

  const getProductMatches = async (productId) => {
    let url =
      process.env.REACT_APP_BACKEND_API + "editor/get/matches/" + productId;
    return axios
      .get(url, {
        headers: {
          Authorization: authenticationToken,
        },
      })
      .then((res) => {
        setProductMatches([...res.data]);
        return res.data;
      });
  };

  const setProductInfos = (product) => {
    setId(product.id);
    setName(product.name);
    setDisabled(product.disabled);
    setGltfFile(product.gltfFileUrl);
    setCompany({
      value: product?.company?.id,
      label: product?.company?.name,
    });

    setMatchProductCode(product.matchProductCode);

    setCategories(product.category);
    setSelectedCategoryList(
      product.category?.map((gCategory) => {
        return { value: gCategory.id, label: gCategory.name };
      })
    );

    setGlobalCategories(product.globalCategory);
    setSelectedG_CategoryList(
      product.globalCategory?.map((category) => {
        return {
          value: category.id,
          label: category.name,
        };
      })
    );

    getAnnotationList(product.id);
    getAnimationAnnotationList(product.id);
    setPMaterialParts(product.pmaterialParts);
    getMaterialGroupByProduct();
    getCompanyMaterialGroups(product.company.id);
    const parsedImageList = product.imageUrlList.map((i) => {
      const parsedUrl = i && i.includes(";") ? i.split(";")[0] : i;
      return parsedUrl;
    });
    setImageList(parsedImageList);

    setEnviroment({
      value: product?.hdr?.id,
      label: product?.hdr?.name,
      text: product?.hdr?.url,
    });

    const lightInfo = lightingObj.map((obj) => {
      if (obj.name === "Exposure") {
        let exposure =
          product.exposure == null || product.exposure == ""
            ? 1
            : product.exposure;
        return { ...obj, value: exposure };
      }
      if (obj.name === "Shadow") {
        return { ...obj, value: product.shadowIntensity };
      }
      return obj;
    });
    setLightingObj(lightInfo);

    getModalOptionsList(product.company.id);
    getProductOptions(product.id);

    getModelGroupByProduct();

    const pTypes = placeTypes.filter((e) => {
      return e.value == product.placeType;
    });
    if (pTypes.length > 0) setPlaceType(pTypes[0]);
  };

  const exportScene = () => {
    const modelViewer = document.getElementById("modelViewer");
    let scene = modelViewer?.scene();
    exporter.parse(scene.children[0].children[1], setExportToGlb, {
      binary: true,
    });
  };

  const setExportToGlb = (glb) => {
    setGltfFile(glb);
  };

  const mapProduct = async () => {
    let newProduct = productJson;
    newProduct.name = name;
    newProduct.dracoLevel = dracoCompressionLevel;
    newProduct.matchProduct = false;
    newProduct.id = id;
    newProduct.matchProduct = exportObj[2].isSelected;
    newProduct.dracoCompress = false; //exportObj[3].isSelected;
    newProduct.matchProductCode = matchProductCode;
    newProduct.cameraOrbit = cameraOrbit;
    newProduct.isNewObj = isNewObj;

    newProduct.company =
      company && company.value
        ? {
            id: company.value,
          }
        : undefined;

    newProduct.category = categories;
    newProduct.globalCategory = globalCategories;

    newProduct.exposure = lightingObj[0].value;
    newProduct.shadowIntensity = lightingObj[1].value;
    newProduct.exportPoster = usePoster;
    newProduct.exportThumbnail = useThumbnail;
    newProduct.hdr =
      environment && environment.value
        ? {
            id: environment.value,
          }
        : null;

    newProduct.placeType = placeType.value;

    newProduct.transmissionParams = transmissionParams;

    setProductJson(newProduct);
    return newProduct;
  };

  const updateSceneMaterials = async () => {
    const modelViewer = document.getElementById("modelViewer");
    if (!modelViewer && modelViewer?.scene()) return;

    try {
      var scene = modelViewer?.scene();
      if (!scene) return;
      setGltfMaterials([]);
    } catch (ec) {
      console.log("ex", ec);
    }

    let newMaterials = [];
    await scene?.traverse(function (object) {
      if (
        object.material &&
        !newMaterials.includes(object.material) &&
        object.name &&
        object.material.name
      ) {
        newMaterials.push(object.material);
      }
    });

    setGltfMaterials(newMaterials);
  };
  const flipTexture = async (flip) => {
    const modelViewer = document.getElementById("modelViewer");
    let scene = modelViewer?.scene();
    scene.children[0].traverse((m) => {
      if (m.type == "Mesh") {
        if (m.material && m.material.map) {
          m.material.map.flipY = !flip;
        }

        if (m.material && m.material.aoMap) {
          m.material.aoMap.flipY = !flip;
        }

        if (m.material && m.material.metallicMap) {
          m.material.metallicMap.flipY = !flip;
        }

        if (m.material && m.material.roughnessMap) {
          m.material.roughnessMap.flipY = !flip;
        }

        if (m.material && m.material.normalMap) {
          m.material.normalMap.flipY = !flip;
        }
      }
    });
  };

  const getCompanyMaterialGroups = async (companyId) => {
    if (!companyId) return [];
    const response = await api.getCompanyMaterialGroups(companyId);
    setCompanyMaterialGroups(response.data);
  };

  const getMaterialGroupByProduct = async () => {
    if (!editorProductInfo.id) return;
    let url = "material/listProductGroups/" + editorProductInfo.id;
    axios
      .get(process.env.REACT_APP_BACKEND_API + url, {
        headers: {
          Authorization: authenticationToken,
        },
      })
      .then((res) => {
        setDefaultProductMaterialGroups(
          res.data.map((mtlGroup) => {
            return {
              value: mtlGroup?.id,
              label: mtlGroup?.company?.name + "-" + mtlGroup?.name,
            };
          })
        );
      });
  };

  const getModelGroupByProduct = async () => {
    if (!editorProductInfo.id) return;

    let url = "product/model/list/productModelGroups/" + editorProductInfo.id;
    axios
      .get(process.env.REACT_APP_BACKEND_API + url, {
        headers: {
          Authorization: authenticationToken,
        },
      })
      .then((res) => {
        let dataModelGroup = res.data[0];
        setDefaultModelGroups([
          { value: dataModelGroup?.id, label: dataModelGroup?.name },
        ]);
      });
  };

  const getAnnotationListByType = (type, setter, productId = editorProductInfo.id) => {
    if (!productId) return;

    let url = `annotation/list/byType/` + productId + "/" + type;
    axios
      .post(process.env.REACT_APP_BACKEND_API + url, null, {
        headers: {
          Authorization: authenticationToken,
        },
      })
      .then((res) => {
        if (typeof res.data == "object") setter(res.data);
      });
  };

  const getAnnotationList = (productId = editorProductInfo.id) => {
    getAnnotationListByType(0, setAnnotationList, productId);
  };

  const getAnimationAnnotationList = (productId = editorProductInfo.id) => {
    getAnnotationListByType(1, setAnimationAnnotationList, productId);
  };

  const refreshAnnotationLists = (productId = editorProductInfo.id) => {
    getAnnotationList(productId);
    getAnimationAnnotationList(productId);
  };

  const deleteAnnotation = (annotationId) => {
    if (!annotationId) return Promise.resolve();

    return axios
      .post(process.env.REACT_APP_BACKEND_API + `annotation/delete/${annotationId}`, null, {
        headers: {
          Authorization: authenticationToken,
        },
      })
      .then(() => {
        setAnnotationList((list) => (list || []).filter((item) => item.id !== annotationId));
        setAnimationAnnotationList((list) => (list || []).filter((item) => item.id !== annotationId));
      });
  };

  const getModalOptionsList = async (companyId) => {
    if (editorProductInfo.id) {
      axios
        .post(
          process.env.REACT_APP_BACKEND_API + "company/products/" + companyId,
          null,
          {
            headers: {
              Authorization: authenticationToken,
            },
          }
        )
        .then((res) => {
          setModelOptionList(
            res.data?.map((product) => {
              return {
                value: product[0],
                label: product[0] + "-" + product[1],
              };
            })
          );
        });
    } else {
      setModelOptionList([]);
    }
  };

  const getProductOptions = async (productId) => {
    if (editorProductInfo.id) return;

    let url = "option/product/list/" + productId;
    axios
      .post(process.env.REACT_APP_BACKEND_API + url, null, {
        headers: {
          Authorization: authenticationToken,
        },
      })
      .then((res) => {
        setProductOptions(res.data);
      });
  };

  const getTags = async () => {
    let res = await api.getTags();
    setTagList(
      res.data.map((tag) => {
        return {
          value: tag.id,
          label: tag.type + " - " + tag.name,
        };
      })
    );
  };

  const getTagGroups = async () => {
    let res = await api.getTagGroups();
    const tagGroups = res.data.map((tag) => {
      let label = tag.name + "-";
      label += tag.type;
      return {
        value: tag.id,
        label: tag.name,
      };
    });
    setTagGroupList(tagGroups);
  };

  const getCompanies = async () => {
    if (companies.length > 0) return;

    axios
      .get(process.env.REACT_APP_BACKEND_API + "editor/company/list", {
        headers: {
          Authorization: authenticationToken,
        },
      })
      .then((res) => {
        setCompanies(
          res.data.map((company) => {
            return { value: company.id, label: company.name };
          })
        );
      });
  };

  const populateContextMaterials = (force) => {
    let p = new Promise((resolve, reject) => {
      if (!force && materials.length > 0) {
        resolve(materials);
        return;
      }

      setMaterials([]);
      axios
        .get(
          process.env.REACT_APP_BACKEND_API + "material/list",
          authorizationHeader
        )
        .then((res) => {
          let d = res.data.body || res.data || [];
          setMaterials(d);
          resolve(d);
        });
    });

    return p;
  };

  const createTagForMaterial = (props) => {
    let model = document.getElementsByClassName("model")[0];
    model.innerHTML = ``;
    model.innerHTML = `
    <sugar-model-viewer 
      id='modelViewer'
      material-search="true"
      ar  
      interaction-prompt="none"
      editor="true"
      showDimension="true"
      shadow-intensity =  ${lightingObj[1].value}
      scrollable="pan-y"
      environment-image= '${
        environment == null
          ? ""
          : environment.text != null
          ? environment.text
          : ""
      }'
      exposure=${lightingObj[0].value}
      ar-scale='fixed'
      camera-controls
      src=${props.src}
      show-model-group
      template="advanced"
      style="height:100vh;"
      quick-look-browsers='safari chrome'/>`;
  };

  const logOut = () => {
    eraseCookie(loginCookieName);
    setAuthenticationToken("");
  };

  const values = {
    logOut,

    exportObj,
    setExportObj,
    isNewObj,
    setIsNewObj,
    id,
    setId,
    disabled,
    setDisabled,
    name,
    setName,
    thumbnail,
    setThumbnail,
    environment,
    setEnviroment,
    lightingObj,
    setLightingObj,

    company,
    companies,
    setCompany,
    setCompanies,
    getCompanies,
    populateContextMaterials,
    materials,

    authenticationToken,
    setAuthenticationToken,

    categories,
    setCategories,
    categoryList,
    setCategoryList,
    globalCategoryList,
    setGlobalCategoryList,
    globalCategories,
    setGlobalCategories,
    tagList,
    setTagList,
    selectedCategoryList,
    setSelectedCategoryList,
    selectedG_CategoryList,
    setSelectedG_CategoryList,

    getTags,
    getTagGroups,
    tagGroupList,

    annotationList,
    setAnnotationList,
    animationAnnotationList,
    setAnimationAnnotationList,
    getAnnotationList,
    getAnimationAnnotationList,
    refreshAnnotationLists,
    deleteAnnotation,
    gltfFile,
    setGltfFile,
    sceneActive,
    setSceneActive,
    exportScene,
    exporter,

    refreshMaterial,
    setRefreshMaterial,

    glbOriginalFile,
    setGlbOriginalFile,
    companyMaterialGroups,
    setCompanyMaterialGroups,
    defaultProductMaterialGroups,
    setDefaultProductMaterialGroups,
    defaultModelGroups,
    setDefaultModelGroups,
    productJson,
    imageList,
    setImageList,

    productToUpdate,
    getProductToUpdate,
    productMatches,
    getProductMatches,

    updateSceneMaterials,

    editorProductInfo,

    mapProduct,
    lowGlb,
    setLowGlb,
    flipTexture,

    modelOptionList,
    productOptions,
    getProductOptions,

    dracoCompressionLevel,
    setDracoCompressionLevel,
    environmentList,
    setEnvironmentList,
    animations,
    setAnimations,

    matchProductCode,
    setMatchProductCode,
    usePoster,
    setUsePoster,
    useThumbnail,
    setUseThumbnail,
    cameraOrbit,
    setCameraOrbit,

    placeType,
    setPlaceType,
    placeTypes,
    setPlaceTypes,
    authorizationHeader,
    setAuthorizationHeader,
    setProductMatches,

    productVariantOptions,

    createTagForMaterial,

    gltfMaterials,
    setGltfMaterials,

    transmissionParams,
    setTransmissionParams,
  };

  return (
    <SettingsContext.Provider value={values}>
      {children}
    </SettingsContext.Provider>
  );
};

export { SettingsContext, SettingsProvider };
